import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return data?.map((item: any) => ({
    id: item?.id,
    key: item?.key ?? 'NA',
    data: {
      id: !isNaN(Number(item?.id)) ? Number(item?.id) : undefined,
      entityId: item?.object?.entity?.entityId,
      amount: `${item?.object?.amount?.netAmount ?? 'NA'}`,
      invoice: item?.object?.invoice,
      methodType: item?.object?.method?.type,
      methodSubType: item?.object?.method?.subType,
      originalId: item?.object?.originalId,
      description: item?.object?.statementDescriptor ?? 'NA',
    },
    type: item?.type,
    className: item?.className,
    username: item?.username,
    approvalStatus: item?.approvalStatus,
    approvalType: item?.approvalType,
  }))
}

const getRiskControlsMidApprovals = (elevated: boolean, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.riskControlMerchantPendingApprovals),
    method: 'GET',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    // body: {
    //   elevated,
    //   type: 'RISK_CONFIG_MID',
    // },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getRiskControlsMidApprovals }
